const STORAGE_KEY = "wb_acquisition";

const parseUtmParams = (search) => {
  const params = new URLSearchParams(search);
  const source = params.get("utm_source");
  const medium = params.get("utm_medium");
  const campaign = params.get("utm_campaign");

  if (!source && !medium && !campaign) {
    return null;
  }

  return {
    acquisition_source: source || null,
    acquisition_medium: medium || null,
    acquisition_campaign: campaign || null,
  };
};

export const captureAcquisitionFromUrl = () => {
  if (typeof window === "undefined" || localStorage.getItem(STORAGE_KEY)) {
    return;
  }

  const acquisition = parseUtmParams(window.location.search);
  if (acquisition) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(acquisition));
  }
};

export const getStoredAcquisition = () => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return {};
    }

    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== "object") {
      return {};
    }

    return {
      ...(parsed.acquisition_source ? { acquisition_source: parsed.acquisition_source } : {}),
      ...(parsed.acquisition_medium ? { acquisition_medium: parsed.acquisition_medium } : {}),
      ...(parsed.acquisition_campaign ? { acquisition_campaign: parsed.acquisition_campaign } : {}),
    };
  } catch (error) {
    return {};
  }
};

export const clearStoredAcquisition = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(STORAGE_KEY);
  }
};
